'use client'

import { createContext, type ReactNode, useContext } from 'react'

/**
 * `<Outlet />` — renders the active child segment inside a shared layout.
 *
 * The App Router delivers a segment's content as the `children` prop of its
 * `layout.tsx`. A layout wraps its subtree in `<OutletProvider value={children}>`,
 * and `<Outlet />` (from `@/routing`) reads it — so shared layout components like
 * `src/components/layout/Layout.tsx` can place the page where they want.
 */
const OutletContext = createContext<ReactNode>(null)

export const OutletProvider = OutletContext.Provider

export const NextOutlet = (): ReactNode => useContext(OutletContext)
